import { Location } from 'history';

export const FAVORITES_HUB = 'favorites_hub';
import { isFavoritesPage, isMarketplacePage, isItemPage, isShopPage, isCSP, isFavoriteSearchesPage, isFavoriteShopsPage, isFavoriteItemsPage } from '../url_helpers';

export enum FavoritesHubPane {
  LiveWatches = 'Watch - Live',
  EndedWatches = 'Watch - Ended',
  Searches = 'Searches',
  Shops = 'Shops',
  Feed = 'Feed',
}

export function trackingSort(location: Location) {
  switch (location.query.sort) {
    case 'price|asc':
      return 'Price Low to High';
    case 'price|desc':
      return 'Price High to Low';
    default:
      return 'Most Recent';
  }
}

export function resolveCurrentView(location: Location) {
  if (isFavoritesPage(location)) {
    return 'favorites_hub';
  } else if (isMarketplacePage(location)) {
    return 'search';
  } else if (isItemPage(location)) {
    return 'listing';
  } else if (isShopPage(location)) {
    return 'shop';
  } else if (isCSP(location)) {
    return 'csp';
  } else {
    // default tracking value for any other page
    return 'etc';
  }
}

export function resolveFavoriteType(location: Location) {
  if (isMarketplacePage(location) || isFavoriteSearchesPage(location)) {
    return 'Search';
  } else if (isItemPage(location) || isFavoriteItemsPage(location)) {
    return 'Item';
  } else if (isShopPage(location) || isFavoriteShopsPage(location)) {
    return 'Shop';
  } else if (isCSP(location)) {
    return 'CSP';
  } else {
    return null;
  }
}
